import { Box, styled, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const StyledImg = styled('img')(() => ({
    maxWidth: '205px',
    marginBottom: '15px'
}));

export const StyledNoLinkedHeader = styled(Typography)(() => ({
    fontWeight: 600,
    fontSize: '18px',
    marginBottom: '15px'
}));

export const StyledNoLinkedDesc = styled(Typography)(() => ({
    color: '#474A59',
    lineHeight: '24px',
}));

export const StyledNoAccountWrapperBox = styled(Box)(() => ({
    background: '#FAFAFC',
    padding: '36px',
    textAlign: 'center'
}));

export const StyledNoAccountBackgroundBox = styled(Box)(() => ({
    maxWidth: '360px',
    display: 'inline-block'
}));

export const StyledInfoBox = styled(Box)(() => ({
    background: '#FAFAFC',
    border: '1px solid #EBEDF5',
    padding: '18px',
    borderRadius: '9px',
    display: 'flex',
    alignItems: 'center',
}));

export const StyledInfoTypography = styled(Typography)(() => ({
    color: '#474A59',
}));

export const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)(() => ({
    fontSize: '18px',
    marginRight: '10px',
    marginTop: '2px',
    color: '#6C6F80'
}));

export const PasswordSpan = styled('span')(() => ({
    fontSize: '20px',
    color: '#111'
}));

export const passwordButtonStyles = { fontSize: '12px', maxHeight: '24px', lineHeight: 1.6, textTransform: 'none', whiteSpace: 'nowrap' };

export const StyledSetUpTypography = styled(Typography)(() => ({
    fontSize: '18px',
    color: '#111',
    fontWeight: 600
}));

export const SessionHeaderTypography = styled(Typography)(() => ({
    fontWeight: 600,
    color: '#111',
}));

export const DeviceImg = styled('img')(() => ({}));

export const cardHeaderStyles = { paddingLeft: '24px', paddingRight: '24px', paddingTop: '20px' };
export const cardContentStyles = { '&:last-child': { paddingTop: '0px', paddingLeft: '24px', paddingRight: '24px', paddingBottom: '14px' } };
export const setUpSignInMethodBlockStyles = { display: 'flex', justifyContent: 'center', background: '#FAFAFC', width: '100%' };
export const setUpSignMethodWrapperStyles = { maxWidth: 310, display: 'inline-block', padding: '30px 0', textAlign: 'center' };
export const setUpSignMethodDesc ={ lineHeight: '24px', maxWidth: 280, display: 'inline-block', marginBottom: '30px', marginTop: '10px' };
export const signInBoxStyles = { marginBottom: '15px', marginTop: '10px' };
export const signInGridStyles = { padding: '15px 0', alignItems: 'center', justifyContent: 'space-between' };
export const signInCredRowPasswordStyles = { display: { xs: 'none', lg: 'flex' }, marginRight: '15px', alignItems: 'center' };
export const signInCredRowButtonGridStyles = { alignSelf: 'center', paddingTop: { xs: 1, sm: 0 } };
export const signInCredRowGridStyles = { padding: '15px 0', alignItems: 'center' };
export const signInCredRowTitleGridStyles = { minWidth: '100px' };

export const deviceSignOutAllStyles = { fontSize: '14px !important', fill: '#fff' };
export const deviceCardActionStyles = { display: 'flex', gap: 2, marginTop: { xs: '10px', sm: 0 } };
export const deviceImgGridStyles = { display: { xs: 'none', sm: 'block' } };
export const deviceImgStyles = { width: { sm: '81px', md: '111px' } };
export const deviceBrowserNameStyles = { display: 'flex', alignItems: 'center', marginBottom: '20px'};
export const deviceActiveRowSignOutStyles = { fontSize: '12px !important', fill: '#0A68F1' };
export const deviceApplicationsBowStyles = { display: 'inline-flex', alignItems: 'center', gap: 0.5 };
export const deviceTooltipStyles = { fontSize: '13px' };
export const deviceChipStyles = { marginLeft: '15px' };
export const deviceActiveRowGridStyles = { padding: '30px 0' };
export const deviceBrowserImgBoxStyles = { display: 'inline-flex', gap: 0.5, marginRight: '10px' };
export const deviceBrowserImgStyles = { alignSelf: 'start', marginTop: '4px' };
export const corporateAccountLinkStyles = {
    fontWeight: 600,
    textDecoration: 'none',
    '& svg': {
        verticalAlign: 'text-top',
        fontSize: '18px',
        marginRight: '5px'
    }
};

export const accountRowListItemStyles = { padding: '18px 0' };
export const cardStyles = { marginBottom: '24px' };